<template>
  <!-- 对齐 App BottomNav：胶囊形背景 + Home / 中央 Scan / Mine -->
  <!-- 激活态橙色用 CSS mask 着色法实现（与 App 端 Image.color 运行时着色机制一致） -->
  <div class="bottom-nav">
    <div class="bottom-nav-inner">
      <!-- Home -->
      <div
        class="bottom-nav-item"
        :class="{ active: active === 'home' }"
        @click="onClick('home')"
      >
        <i class="bottom-nav-icon bottom-nav-icon-home"></i>
      </div>

      <!-- 中央 Scan 按钮（始终是橙色，App 端固定） -->
      <div class="bottom-nav-scan" @click="onScan">
        <i class="bottom-nav-icon bottom-nav-icon-scan"></i>
      </div>

      <!-- Mine -->
      <div
        class="bottom-nav-item"
        :class="{ active: active === 'mine' }"
        @click="onClick('mine')"
      >
        <i class="bottom-nav-icon bottom-nav-icon-mine"></i>
      </div>
    </div>

    <!-- 默认扫码弹层（使用方未监听 scan 事件时启用，对齐 map 页面实现） -->
    <div class="bottom-nav-pickup" v-if="isPickUpShow" @click="isPickUpShow = false">
      <ScanQr @scanQr="onScanQr" @back="isPickUpShow = false" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import ScanQr from "@/views/scanQr/scanQr.vue"
import { QR_CODE } from "@/apis/cabinet"
export default {
  name: "BottomNav",
  components: { ScanQr },
  props: {
    // 当前激活的 tab：'home' | 'mine' | ''（空表示无高亮，用于非 home/mine 页）
    active: { type: String, default: "" }
  },
  data() {
    return {
      isPickUpShow: false
    }
  },
  computed: {
    // 用于 onClick/onScan 中判断登录态，决定 Mine/Scan 跳 /setting、/login
    ...mapState(["user", "token"])
  },
  methods: {
    onClick(key) {
      if (key === "home") {
        // 主页为 /map（地图首页）；catch 吞掉在 /map 页重复点击的 NavigationDuplicated
        this.$router.push("/map").catch(() => {})
      } else if (key === "mine") {
        if (this.user) {
          this.$router.push("/setting")
        } else {
          this.$router.push("/login")
        }
      }
    },
    onScan() {
      // 使用方监听了 scan 事件时交给使用方（map/home 页有各自实现）
      if (this.$listeners.scan) {
        this.$emit("scan")
        return
      }
      // 默认扫码（对齐 map 页面 goScan）：已登录 → 调起 H5 扫码，未登录 → 跳登录
      if (this.user && this.token) {
        this.isPickUpShow = true
      } else {
        this.$router.push("/login")
      }
    },
    onScanQr(qr) {
      this.isPickUpShow = false
      const arr = (qr || "").split("=")
      const qrcode = arr[1] || arr[0]
      this.onScanCode(qrcode)
    },
    // 默认扫码查询（对齐 map 页面 onScan）：QR_CODE 查询后，
    // 有进行中租借弹确认跳订单，否则跳租借结果页；
    // confirm 挂 body 下，非首页跟随服务端主题色，不显式指定颜色
    onScanCode(qrcode) {
      this.$loading(true)
      this.$post(
        `${QR_CODE}?id=${qrcode}&usePriceUnit=true`,
        {},
        (resp) => {
          this.$loading(false)
          this.$store.commit("cabinet", {
            qrcode,
            ...resp
          })
          if (resp.zujieNum && resp.zujieNum > 0 && !resp.haveMifiBattery) {
            this.$confirm({
              title: this.$t("home").msg_fail_title,
              content: `${this.$t("home").msg_rentcount}`.format(resp),
              confirmText: this.$t("msg").vieworder,
              cancelText: this.$t("msg").cancel
            })
              .then(() => {
                this.$router.push("/order")
                this.$store.commit("qrcode", "")
              })
              .catch(() => {
                this.$store.commit("qrcode", "")
              })
          } else {
            this.$router.push("/home?cabinetshow=true")
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    }
  }
}
</script>

<style lang="less" scoped>
.bottom-nav {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  // 顶部留白让胶囊悬浮感、底部留白适配全面屏安全区
  padding: 20px 0 30px;

  &-inner {
    width: 500px;
    height: 130px;
    background: #f8f6fc;
    border-radius: 50px;
    padding: 0 36px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }

  &-item {
    cursor: pointer;
    padding: 4px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  // 通用图标：CSS mask 着色法
  // 用 background-color 控制颜色，mask-image 用原图作 mask
  // 默认灰色，active 时通过 .bottom-nav-item.active 选择器覆盖为橙色
  &-icon {
    display: block;
    width: 58px;
    height: 58px;
    background-color: #cfcece; // 默认灰色
    -webkit-mask-size: 100% 100%;
    mask-size: 100% 100%;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
    transition: background-color 0.2s;

    &-home {
      -webkit-mask-image: url(../../assets/imgs/home_tab_home.png);
      mask-image: url(../../assets/imgs/home_tab_home.png);
    }

    &-mine {
      -webkit-mask-image: url(../../assets/imgs/home_tab_mine.png);
      mask-image: url(../../assets/imgs/home_tab_mine.png);
    }

    &-scan {
      // scan 按钮背景始终橙色，所以图标 mask 颜色固定白色
      width: 42px;
      height: 42px;
      background-color: #fff;
      -webkit-mask-image: url(../../assets/imgs/home_tab_scan.png);
      mask-image: url(../../assets/imgs/home_tab_scan.png);
    }
  }

  // 激活态：图标变主题色
  &-item.active &-icon-home,
  &-item.active &-icon-mine {
    background-color: #ff8800;
  }

  &-scan {
    // 中央 scan 按钮：对齐 App 端，与 Home/Mine 同一基线，不凸出胶囊
    width: 92px;
    height: 92px;
    background: #ff8800;
    border-radius: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(255, 136, 0, 0.3);
    cursor: pointer;
  }

  // 默认扫码弹层遮罩（对齐 map 页 .map-pickup）
  &-pickup {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 200;
    background: rgba(0, 0, 0, 0.5);
  }
}
</style>
